import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';

import { BalanceButton } from '../BalanceButton';
import { BalanceMenu } from '../BalanceMenu';
import { useBalanceMenuButton } from './useBalanceMenuButton';

export const BalanceMenuButton = () => {
  const {
    anchorEl,
    chargingModel,
    handleClose,
    handleOpen,
    hasStatusTransition,
    isBalanceMenuOpened,
    isLoading,
    isLoggedIn,
  } = useBalanceMenuButton();

  return (
    <GuardAccountPermission permission={AccountPermission.Billing}>
      <BalanceButton
        balance={chargingModel?.balance.credits ?? 0}
        isLoading={isLoading}
        isLoggedIn={isLoggedIn}
        isMenuOpen={isBalanceMenuOpened}
        hasStatusTransition={hasStatusTransition}
        handleClose={handleClose}
        handleOpen={handleOpen}
      />
      <BalanceMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        open={isBalanceMenuOpened}
      />
    </GuardAccountPermission>
  );
};
